import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
interface ToastMessage {
  text: string;
  timestamp: number;
}
@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private recentMessages: ToastMessage[] = [];
  constructor(private snackBar: MessageService) { }
  private isDuplicate(message: string, detail?: string): boolean {
    const combined = `${message}-${detail}`;
    const now = Date.now();

    // Check if message already shown within last 1 second
    for (const msg of this.recentMessages) {
      if (msg.text === combined && now - msg.timestamp < 1000) {
        return true;
      }
    }

    // Add new message to history
    this.recentMessages.push({ text: combined, timestamp: now });

    // Keep only the last 4 messages
    if (this.recentMessages.length > 4) {
      this.recentMessages.shift();
    }

    return false;
  }


    showError(message?: string, desc?: string, duration: number = 4000) {
    const finalMessage = message?.trim() ? message : 'An error occurred. Please try again.';

    if (!this.isDuplicate(finalMessage, desc)) {
      this.snackBar.add({
        severity: 'error',
        summary: finalMessage,
        detail: desc,
        life: duration
      });
    }
  }
  showSuccess(message: string, desc?: string, duration: number = 4000) {
    if (!this.isDuplicate(message, desc)) {
      this.snackBar.add({ severity: 'success', summary: message, detail: desc, life: duration });
    }
  }

  showInfo(message: string, desc?: string, duration: number = 4000) {
    if (!this.isDuplicate(message, desc)) {
      this.snackBar.add({ severity: 'info', summary: message, detail: desc, life: duration });
    }
  }
}
